module.exports = __webpack_public_path__ + "static/media/floor_nw.6741a20e.png";